import { AccountBadge } from './AccountBadge'

/**
 *
 * @param {{fulfillmentStatus: string}} props
 */
export const AccountOrderBadge = ({ fulfillmentStatus }) => {
  switch (fulfillmentStatus) {
    case 'transit': {
      return <AccountBadge color="YELLOW" title={'In transit'} className={'py-1'} />
    }
    case 'delayed': {
      return <AccountBadge color="YELLOW" title={'Delayed'} className={'py-1'} />
    }
    case 'delivered': {
      return <AccountBadge color="YELLOW" title={'Delivered'} className={'py-1'} />
    }
    case 'pending': {
      return <AccountBadge color="YELLOW" title={'Pending'} className={'py-1'} />
    }
    case 'fulfilled': {
      return <AccountBadge color="GREEN" title={'Fulfilled'} className={'py-1'} />
    }
    case 'refunded': {
      return <AccountBadge color="RED" title={'Refunded'} className={'py-1'} />
    }
    case 'partially_refunded': {
      return <AccountBadge color="RED" title={'Partially refunded'} className={'py-1'} />
    }
    case 'cancelled': {
      return <AccountBadge color="RED" title={'Cancelled'} className={'py-1'} />
    }
    default: {
      return <></>
    }
  }
}
